import { forwardRef } from 'react';

import { ActionIcon, TextInput, TextInputProps } from '@mantine/core';
import { IconClose, IconSearch } from 'ui-icons';

import classes from './SearchInput.module.css';

interface SearchInputProps extends TextInputProps {
  defaultValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
}

const SearchInput = forwardRef<HTMLInputElement, Partial<SearchInputProps>>((props, ref) => {
  return (
    <TextInput
      leftSection={!props.value && <IconSearch />}
      rightSection={
        props.value ? (
          <ActionIcon
            variant="transparent"
            c="gray"
            onClick={() => {
              props.onChange?.({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);
            }}
            size="xs"
          >
            <IconClose />
          </ActionIcon>
        ) : null
      }
      {...props}
      classNames={{
        input: classes.input,
      }}
      ref={ref}
    />
  );
});

SearchInput.displayName = 'SearchInput';

export { SearchInput };
